import { compose, join, prepend, props } from 'ramda';

import { domain as defaultDomain } from 'config/selectors';
import isUrl from 'app/router/helpers/isUrl';

const buildUrl = (pathString, base = defaultDomain) =>
  isUrl(pathString) ? pathString : `//${base}${pathString}`;

const buildFullUrl = compose(
  join(''),
  prepend(window.location.origin),
  props(['pathname', 'search', 'hash']),
);

export { buildUrl, buildFullUrl };
